import Actions from '../../odata/actions';

const actions = new Actions('agreementDefault', 'agreementDefaults');

export default actions;
